import React from "react";
import { Table as FlowbiteTable, TableProps } from "flowbite-react";

interface CourieTableProps extends TableProps {
  Head?: typeof FlowbiteTable.Head;
  HeadCell?: typeof FlowbiteTable.HeadCell;
  Body?: typeof FlowbiteTable.Body;
  Row?: typeof FlowbiteTable.Row;
  Cell?: typeof FlowbiteTable.Cell;
}

const Table: React.FC<CourieTableProps> & {
  Head: typeof FlowbiteTable.Head;
  HeadCell: typeof FlowbiteTable.HeadCell;
  Body: typeof FlowbiteTable.Body;
  Row: typeof FlowbiteTable.Row;
  Cell: typeof FlowbiteTable.Cell;
  // Footer: typeof FlowbiteTable.Footer;
} = ({ children, ...props }) => {
  const { Head, Body } = FlowbiteTable;

  return (
    <>
      <FlowbiteTable style={{ height: "100%" }} {...props}>
        {children}
      </FlowbiteTable>
      {/* <Pagination /> */}
    </>
  );
};

Table.Head = FlowbiteTable.Head;
Table.HeadCell = FlowbiteTable.HeadCell;
Table.Body = FlowbiteTable.Body;
Table.Row = FlowbiteTable.Row;
Table.Cell = FlowbiteTable.Cell;

export { Table };
